'use client';

import React, { useState } from 'react';
import { DMImage } from '@/components/custom-image/custom-image';
import ReactPlayer from 'react-player';

const CourseIntroVideo = ({ link }: { link: string }) => {
  const [isReady, setIsReady] = useState(false);
  const [isVideoError, setIsVideoError] = useState(false);
  return (
    <>
      {isVideoError && (
        <div className='flex justify-center flex-col items-center gap-3 w-full h-full'>
          <DMImage
            src={'/images/play-list/no-video.png'}
            alt='video error'
            width={80}
            height={80}
            className='max-sm:w-[84px]'
          />

          <p className='sm:text-sm text-xs text-center'>
            Something went wrong, Please refresh the page
          </p>
        </div>
      )}

      <div
        style={{ display: isReady ? 'block' : 'none' }}
        className='h-full rounded-sm overflow-hidden'
      >
        <ReactPlayer
          url={link}
          controls
          onReady={() => setIsReady(true)}
          onError={() => {
            setIsVideoError(true);
          }}
          playsinline
          width='100%'
          height='100%'
          progressInterval={100}
          config={{
            vimeo: {
              playerOptions: {
                responsive: true,
                autoplay: false,
              },
            },
          }}
        />
      </div>
    </>
  );
};

export default CourseIntroVideo;
